import React from "react";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import { MAP_MAIN_PAGE_PATH } from "utils/constants/paths";

const MapMainPage = Loadable(React.lazy(() => import("./View")));

export const MapMainPageRoute: IRouteItem = {
  path: MAP_MAIN_PAGE_PATH,
  element: React.createElement(MapMainPage),
  name: "Map Main Page",
};
